import React from 'react'

import Box from '../components/Box'
import GlyphChain from '../icons/GlyphChain'

export const IsConnected = ({ t }) => {
  return (
    <Box className='pv3 ph4 ma4' style={{ background: '#F8F8F8' }}>
      <div>
        <div className='flex flex-wrap items-center'>
          <GlyphChain style={{ height: 76 }} className='fill-reen' role='presentation' />
          <h1 className='times-new-roman fw4 charcoal ma0 f3 greenmod'>You have connected to THDJBR!</h1>
        </div>
        <div className=''><strong>Welcome to our dapp.  Now, You can take benefits of Blockchain, distributed Webs, distributed storages, and distributed databases.</strong></div>
        <p className='fw6 mt1 ml3-ns w-100'></p>
      </div>
    </Box>
  )
}

export default IsConnected;
